export default function Umbrella(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='42'
      height='38.468'
      viewBox='0 0 42 38.468'
      fill='#152a46'
      {...props}
    >
      <path
        id='umbrella'
        d='M19.072.118a19.946,19.946,0,0,0-7.1,1.928A21.151,21.151,0,0,0,2.01,11.972,21.571,21.571,0,0,0,0,19.026a2.448,2.448,0,0,0,.123.779,1.361,1.361,0,0,0,.41.615.751.751,0,0,0,.472.41,2.265,2.265,0,0,0,.759.123H19.236v10.5a7.073,7.073,0,0,0,7.014,7.014,7.073,7.073,0,0,0,7.014-7.014,1.764,1.764,0,1,0-3.527,0,3.486,3.486,0,0,1-6.973,0v-10.5H40.236A2.265,2.265,0,0,0,41,20.831a.751.751,0,0,0,.472-.41q.123-.246.328-.615A1.581,1.581,0,0,0,42,19.026a20.359,20.359,0,0,0-2.42-8A20.864,20.864,0,0,0,27.4.938,20.209,20.209,0,0,0,19.072.118ZM21,17.468H3.855A17.251,17.251,0,0,1,9.188,7.952,18.266,18.266,0,0,1,19.236,3.44a16.6,16.6,0,0,1,6.48.615,17.654,17.654,0,0,1,5.66,2.789,18.319,18.319,0,0,1,4.348,4.594,17.362,17.362,0,0,1,2.42,6.029ZM42,36.7'
      />
    </svg>
  )
}
